var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 0C15.9247 0 0 15.9247 0 35.5C0 55.0753 15.9247 71 35.5 71C55.0753 71 71 55.0753 71 35.5C71 15.9247 55.0753 0 35.5 0ZM50.2917 50.2917H20.7083C19.0724 50.2917 17.75 48.9664 17.75 47.3334C17.75 45.7004 19.0724 44.3751 20.7083 44.3751H50.2916C51.9275 44.3751 53.2499 45.7004 53.2499 47.3334C53.25 48.9663 51.9276 50.2917 50.2917 50.2917ZM50.2917 38.4583H20.7083C19.0724 38.4583 17.75 37.133 17.75 35.5C17.75 33.867 19.0724 32.5417 20.7083 32.5417H50.2916C51.9275 32.5417 53.2499 33.867 53.2499 35.5C53.2499 37.133 51.9276 38.4583 50.2917 38.4583ZM50.2917 26.625H20.7083C19.0724 26.625 17.75 25.2997 17.75 23.6667C17.75 22.0337 19.0724 20.7084 20.7083 20.7084H50.2916C51.9275 20.7084 53.2499 22.0337 53.2499 23.6667C53.2499 25.2997 51.9276 26.625 50.2917 26.625Z",
    fill: "#E0AF04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.82b860bd13d39f006222291c756ed6c8.svg";
export { ForwardRef as ReactComponent };